import { memo } from "react";
import _ from "lodash";

import { colors } from "theme/palette";
import { TABLE_CELL_STYLES, TABLE_HEADER_STYLES } from "utils/constants";

import Box from "components/Box";
import Text from "components/Text";

import { ITable } from "entities/TableStorage/sdk";

export interface ITableProps {
  tableData: ITable["rows"];
}

const Table = ({ tableData }: ITableProps) => {
  const [headers, ...rows] = tableData;

  return (
    <Box
      sx={{
        maxWidth: "100%",
        "table, th, td": {
          border: `1px solid ${colors.blue20}`,
          borderCollapse: "collapse",
        },
      }}
    >
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            {headers.cells.map(({ value }, index) => (
              <td key={index} style={TABLE_HEADER_STYLES}>
                <Text variant="text2" fontWeight={500} whiteSpace="pre-line">
                  {value}
                </Text>
              </td>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td style={TABLE_CELL_STYLES} colSpan={headers.cells.length}>
                <Text variant="text2" textAlign="center">
                  ...
                </Text>
              </td>
            </tr>
          ) : (
            rows.map((row, index) => (
              <tr key={index}>
                {row.cells.map(({ value }, cellIndex) => (
                  <td key={cellIndex} style={TABLE_CELL_STYLES}>
                    <Text variant="text2" whiteSpace="pre-line">
                      {value}
                    </Text>
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </Box>
  );
};

export default memo(Table, (prevProps, nextProps) =>
  _.isEqual(prevProps, nextProps)
);
